import { IUnitedSections, PDF } from 'constants/businessToolSections';
import { FOR_BANK_SECTIONS, IForBankSections } from 'constants/businessToolSections/forBank';

export function isBusinessToolSection(section: IUnitedSections): section is IForBankSections {
  return [...Object.values(FOR_BANK_SECTIONS), PDF.TITLE_PAGE_AND_TABLE_OF_CONTENTS].includes(section as any);
}
